import '@ta-interaktiv/semantic-ui/semantic/dist/components/label.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/statistic.css'
import { connect } from 'react-redux'
import styles from './styles.module.scss'
import { RequestStatus } from './reducer'
import { AppState } from 'stores/index'
import React, { FC, useContext } from 'react'
import { LocaleContext } from 'contexts/locale'

const loadingIndicator = ({
  loadingStatus
}: {
  loadingStatus: RequestStatus
}) => {
  let locale = useContext(LocaleContext)
  const messages = require('./locales/' + locale + '.yml')

  switch (loadingStatus) {
    case 'loading':
      return (
        <div className={`ui green large label ${styles.loadingIndicator}`}>
          <i className='circle notched loading icon' />
          {messages['loading']}
        </div>
      )

    case 'error':
      return (
        <div className={`ui red large label ${styles.loadingIndicator}`}>
          <i className='warning sign icon' />
          {messages['error']}
        </div>
      )

    case 'success':
    default:
      return null
  }
}

function mapStateToProps({ requestStatus }: AppState) {
  return {
    loadingStatus: requestStatus
  }
}

export const LoadingIndicator = connect(
  mapStateToProps,
  undefined
)(loadingIndicator)

export default LoadingIndicator
